import { useEffect, useState } from "react";
import { getAuditLogs } from "../../../../callApi/httpservice";
import HistoryLogsTable from "../../HistoryLogsTable";

function HistoryLogs() {
  const take: number = 10;
  const [items, setItems] = useState<any>(null);
  const [offset, setOffset] = useState<number>(0);
  const [skip, setSkip] = useState<number>(0);
  const [pageCount, setPageCount] = useState(0);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [filterStartDate, setFilterStartDate] = useState<any>(null);
  const [filterEndDate, setFilterEndDate] = useState<any>(null);
  const [filterBy, setFilterBy] = useState<string>("");
  const [filterValue, setFilterValue] = useState<string>("");
  const callApiGetHistoryLogs = async (
    take: number,
    skip: number,
    filterBy?: string,
    filterValue?: string,
    filterStartDate?: any,
    filterEndDate?: any
  ) => {
    setItems(null);
    setIsFetching(true);
    if (filterStartDate) {
      const start = new Date(filterStartDate);
      start.setHours(0, 0, 0, 0);
      const startAt = new Date(start).getTime() / 1000;
      filterStartDate = +startAt;
    }
    if (filterEndDate) {
      const end = new Date(filterEndDate);
      end.setHours(23, 59, 59, 999);
      const endAt = new Date(end).getTime() / 1000;
      filterEndDate = +endAt;
    }
    const result: any = await getAuditLogs({
      filterBy,
      filterValue,
      filterStartDate,
      filterEndDate,
      take,
      skip,
      sortDesc: true,
      sortBy: "createdAt",
    });
    if (result.status === 200) {
      setItems(result.data[0]);
      let count = result.data[1] as number;
      if (count % take === 0) {
        setPageCount(count / take);
      } else {
        setPageCount(Math.floor(count / take) + 1);
      }
    }
    setIsFetching(false);
  };
  const handlePageClick = (e: any) => {
    const selectedPage = e.selected;
    setOffset(selectedPage);
    setSkip(selectedPage * take);
  };
  useEffect(() => {
    callApiGetHistoryLogs(
      take,
      skip,
      filterBy,
      filterValue,
      filterStartDate,
      filterEndDate
    );
  }, [offset]);
  return (
    <>
      <div className="bg-white xsm:p-1 xsm:pt-3 md:pt-5 xl:pt-10 md:p-5 xl:p-10 shadow-lg rounded-lg text-[14px]">
        <HistoryLogsTable
          items={items}
          pageCount={pageCount}
          handlePageClick={handlePageClick}
          offset={offset}
          isFetching={isFetching}
          callApiGetHistoryLogs={callApiGetHistoryLogs}
          take={take}
          skip={skip}
          filterStartDate={filterStartDate}
          filterEndDate={filterEndDate}
          filterBy={filterBy}
          filterValue={filterValue}
          setFilterStartDate={setFilterStartDate}
          setFilterEndDate={setFilterEndDate}
          setFilterBy={setFilterBy}
          setFilterValue={setFilterValue}
        />
      </div>
    </>
  );
}

export default HistoryLogs;
